import React, { useState, memo } from "react";
import {
	Input, Button,
	Progress
} from "reactstrap";
import Sound from 'react-sound';
import { s3base } from "api.js";
import Microphone from "../../../assets/images/MicrophoneCheck.png";

const HeadsetCheck = memo( function HeadsetCheck({ setNextFlag }) {
	const [volume, setVolume] = useState(100);
	const [soundPer, setSoundPer] = useState(0);
	const [soundStatus, setSoundStatus] = useState(false);

	const soundOff = () => {
		setSoundStatus(false);
		setNextFlag(true);
	}

	const handleSongPlaying = (obj) => {
		setSoundPer(obj.position*100/obj.duration);
	}

	const handleSongFinishedPlaying = () => {
		soundOff();
	}

	return (
		<div className="col-xs-12 successContent">
			<div className="row">
				<div className="col-sm-8">
					<h4 className="mt-0">Headset check</h4>
					<h6>This is an opportunity to check that your headset is working correctly</h6>
					<ol>
						<li>Put your headset on and adjust it so that if it's comfortably over your ears</li>
						<li>When you are ready. cilck on the play button. You hear a short recording</li>
						<li>If you do not hear anything in your headphones while the status reads Playing. Raise your hard to get the alteration of the Test Administator</li>
					</ol>

					<div className="currentStatus">
						<p>Status: Click Play to begin<br></br>Volume</p>
						<Input
							placeholder="Volume"
							type="range"
							min="0"
							max="100"
							step="1"
							defaultValue={volume}
							onInput={ (e) => setVolume(e.target.value) }
						/>
						<br></br>

						<Progress
							color="info"
							value={soundPer}
						/>

						<div className='stop-btn'>
							<Button
								color="success"
								disabled={soundStatus}
								onClick={() => setSoundStatus(true)}
								className="p-5px"
								size="xs"
							>Play</Button>
                        	
                        	<Button
                        		color="success"
                        		disabled={!soundStatus}
                        		onClick={soundOff}
                        		className="p-5px"
                        		size="xs"
                        	>Stop</Button>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
                    <div className="testingImgOuter">
                      <img
                        src={Microphone}
                        alt="headset"
                      />
                    </div>
                </div>				
			</div>

			<Sound
				autoLoad={true}
				url={`${s3base}/ptedata/ptemedia/AUD (2)_1539694341.mp3`}
				playStatus={soundStatus ? Sound.status.PLAYING : Sound.status.STOPPED}
				onPlaying={handleSongPlaying}
				onFinishedPlaying={handleSongFinishedPlaying}
				volume={volume}
			/>
		</div>
	);	
});

export default HeadsetCheck;